import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  of: {
    defaultMessage: 'of',
    id: 'app.components.StyledPagination.of',
  },
  page: {
    defaultMessage: 'Page',
    id: 'app.components.StyledPagination.page',
  },
  prev: {
    defaultMessage: 'Prev',
    id: 'app.components.StyledPagination.prev',
  },
});
